import ReactGA from 'react-ga';
import { getState } from 'library/local-storage';
export var analytics = {
    event: function (action, label, value) {
        if (label === void 0) { label = null; }
        if (value === void 0) { value = null; }
        ReactGA.event({ category: getState().game.name, action: action, label: label, value: value });
    },
};
